// Angular
import { ChangeDetectorRef, Component, EventEmitter, OnInit, ViewChild, Output,Input } from '@angular/core'
import { MatPaginator } from '@angular/material'
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { A, C } from '@angular/cdk/keycodes'
import { Observable,BehaviorSubject } from 'rxjs'
import { formatDate } from '@angular/common'
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
registerLocaleData(localeFr, 'fr');
// Services
import { LayoutConfigService } from '../../../../../core/_base/layout'
import { AppService, ConsultationService, ParameterService, StateService, DialogService, ListeService, PanierService, InstructionService, VisiteService, PageService } from '../../../../../services'
//Component
import { PanierInstructionComponent } from '../../../layout/dialogs/panier-instruction-dialog/panier-instruction.component';
import { ConsultationDialogComponent } from '../../../layout/dialogs/consultation-dialog/consultation-dialog.component';
import { ConsultationMoveComponent } from '../../../layout/dialogs/consultation-move-dialog/consultation-move.component';
import { ConfirmComponent } from '../../../layout/dialogs/confirm-dialog/confirm.component'
import { ChoiceCourrierComponent } from "../../../layout/dialogs/choice-courrier-dialog/choice-courrier.component"
import { EtapeinstructionComponent } from '../../../layout/dialogs/etapeinstruction-dialog/etapeinstruction.component'
import { VisiteDialogComponent } from '../../../layout/dialogs/visite-dialog/visite-dialog.component';
import { LoadDialogComponent } from '../../../layout/dialogs/load-dialog/load.component'

import { InstructionActionsDialog } from '../../../content/actions/instruction-actions-dialog/instruction-actions-dialog.component'
//Interfaces
import { PanierLine, Panier } from '../../../../../Interfaces/Panier'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { VisiteActionsDialog } from '../../actions/visite-actions-dialog/visite-actions-dialog.component';
import { ConsultationStateChangeDialog } from '../../../layout/dialogs/consultation-statechange-dialog/consultation-statechange.component';
import { ConsultationShiftDialog } from '../../../layout/dialogs/consultation-shift/consultation-shift.component';

const KEY = 'PANNIER-LIST'

@Component({
    selector: 'atyl-panier-list',
    templateUrl: './panier-list.component.html',
    styleUrls: ['panier-list.component.scss'],
})
@Stringable({
    path: 'views/pages/dashboard/dashboard',
    key: KEY,
})
export class PanierListComponent implements OnInit {
   	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator

    @StringableValues(KEY)
    strings: any;

	inited = new EventEmitter<any>();
	@Output() lengthInstru: EventEmitter<number> = new EventEmitter<number>();
	@Output() rowClicked: EventEmitter<any> = new EventEmitter<any>();
	loading:boolean = false;

    currentPage: number = 0;
    columns:any[]=[
	{
		id:"selectable",
		label:"",
		visible: true
	},
	{
			id:"reference",
			label:"Référence",
			visible: true
	},
	{
		id:"dossierLibelle",
		label:"Dossier",
		visible: true
	},
	{
		id:"instructionLibelle",
		label:"Instruction"		,
		visible: false
	},
	{
		id:"consultationLibelle",
		label:"Séance"		,
		visible: false
	},
	{
		id:"visiteLibelle",
		label:"RDV"		,
		visible: false
	}
	];

	typeRow:any;
	loadingInstru: any = true;
	loadingInstruction: boolean = false;
	columnsInstruction: any = [];
    dataInstruction: any = [];
    PaginationInstruction: number = 10;
    currentPageInstruction: any;
    sortInstruction: any;
    lengthInstruCount: number = 0;
    codePageInstructionsPanier = "INSTRUCTIONS_PANIER"

   	panier:Panier;
	get:boolean;
	result:any;
	panierBdd:any;

   	disabledAction:boolean=true;
   	wideAction:boolean=true;
   	selectable:Object;

    listCode:string="SYNTHESE";
    listCodePage:string="SYNTHESE_FILTRE";

    demande:any;
	user:any;
	element:any[] = [];
	ligne:any;
	options:any = [];
	idTab:any=[];
	etats:any=[];
    //MODIF AXEL
    pages:any=[];
    pageInstructions:any=[];

    constructor(
	    private dialogService: DialogService,
        private layoutConfigService: LayoutConfigService,
        private parameterService: ParameterService,
        private stateService: StateService,
		private appService: AppService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
		private snackbar: MatSnackBar,
        private changeDetectorRef: ChangeDetectorRef,
		private panierService:PanierService,
        private listService: ListeService,
		private instructionService: InstructionService,
		private consultationService: ConsultationService,
		private visiteService : VisiteService,
        private pageService : PageService
    ) {
    }

    ngOnInit(): void {
        console.log('Panier_List_Component')

		this.stateService.resetP.subscribe((status:boolean) => {
			if(status == true){
				this.panier = new Panier();
				this.stateService.panier.next(this.panier);
				this.changeDetectorRef.detectChanges();
			}
		});
		this.stateService.resetP.next(false);

		this.stateService.panier.subscribe((panier: Panier) => {
			this.panier = panier;
			
			this.wideAction=!(this.panier 
			&& this.panier.lines!=undefined 
			&& this.panier.lines.length>0);
			
			console.log("user panier on init",this.panier)
			this.changeDetectorRef.detectChanges();
		});
		this.stateService.demande.subscribe((demande) => {
            this.demande = demande;
        });

		this.stateService.PanierGet.subscribe((boolean:boolean)=>{
			if(boolean == true) {
				this.loading = true;
				this.changeDetectorRef.detectChanges();

				this.getPanier();

				this.loading = false;
				this.changeDetectorRef.detectChanges();
			}
		});

		this.stateService.reloadPanier.subscribe((status:boolean)=>{
			if(status == true){
				this.loading = true;
				this.changeDetectorRef.detectChanges();

				this.loadPanier(this.panier);
				this.inited.emit(this.panier);

				this.loading = false;
				this.changeDetectorRef.detectChanges();
			}
		});

        this.pageService.get(this.codePageInstructionsPanier).subscribe(
            (response) => {
                this.pageInstructions = response.result;
            },
            (error) => {
                console.error('Erreur lors de la récupération des pages :', error);
            }
        );

    }

	getInitedEmitter(){
		return this.inited;
	}

	rowTableClicked(event:any) {
		if(event.consultation) {
			this.router.navigate(['/home/consultation/' + event.consultation.ID], {
				relativeTo: this.activatedRoute,
			})
		} else {
			this.router.navigate(['/home/dossier/' + event.dossier.type + '/' + event.dossier.dossierID], {
				relativeTo: this.activatedRoute,
			})
		}
    }

    selectChanged(event:any) {

		this.disabledAction=true;        
		this.selectable=event;
		console.log("this.selectable ",this.selectable);

		Object.keys(this.selectable).forEach(key => {
			this.disabledAction=false;
		} );

       	this.changeDetectorRef.detectChanges();

	}

	loadPanier(element){
		this.inited.emit(element);
		this.changeDetectorRef.detectChanges();
		this.stateService.reloadPanier.next(false);
	}

	reloadPanier(data){
        console.log("this.selectable",this.selectable,this.panier.lines)
		this.stateService.reloadPanier.next(true);
		this.changeDetectorRef.detectChanges();
		if(data != ''){
			let snackBarRef = this.snackbar.open(data.message,'', {
				duration: 1500
			});
			console.log("méthode "+ data.methode +" terminée")
		}
	}

	getPanier(){
		this.panierService.get().subscribe((res: JSONRpcResponse) => {
			if(res){
				console.log('panier:get ',res)
				this.wideAction=true;
				if(res.result.length != undefined && res.result.length != 0){
					
					for(let i=0;i<res.result.length;i++){
						this.ligne = res.result[i].lignes;
					}
					this.wideAction=false;
					if(this.ligne.length != 0) {
						for(let i=0;i<this.ligne.length;i++){
							let line:PanierLine=new PanierLine();
							line.id = this.ligne[i].ID;
							line.user=this.stateService.user.value.id;

							if(this.ligne[i].dossier){
								line.dossier = this.ligne[i].dossier;
							} else {
								line.dossier = '';
							}

							if(this.ligne[i].instruction){
								line.instruction = this.ligne[i].instruction;
							} else {
								line.instruction = '';
							}

							if(this.ligne[i].consultation){
								line.consultation = this.ligne[i].consultation;
							} else {
								line.consultation = '';
							}

							if(this.ligne[i].visite){
								line.visite = this.ligne[i].visite;
							} else {
								line.visite = '';
							}

							this.panier.lines.push(line);
							this.changeDetectorRef.detectChanges();
						}
						this.inited.emit(this.panier);
						this.changeDetectorRef.detectChanges();
					} else {
						console.log("Panier existant mais vide");
					}
				} else {
					console.log("Panier non existant");
				}
			}
		});
		this.loading = false;
		this.changeDetectorRef.detectChanges();
		this.stateService.PanierGet.next(false);
	}

	savePanier(){

		this.element = [];

		this.stateService.user.subscribe((user) => {
            if (user) {
                this.user = user;
            }
        });
		Object.keys(this.selectable).forEach(key => {
			let line:PanierLine=this.selectable[key];
			this.element.push(line);
		});

		this.panierService.set(this.element).subscribe((res: JSONRpcResponse) => {
			if(res){
				console.log('panier:set ',res)
				if(res.result) {
					for(let i=0;i<res.result.length;i++){
						this.result = res.result[i];
					}
					if(this.result.lignes.length>0){
						if(this.result.lignes.length == this.element.length){
							let data = {
								message:'Panier enregistré.',
								methode:"savePanier"
							}
							this.reloadPanier(data)
						}
					}
				}
			}
		});
	}

    removePanierItems() {

		this.element = [];
		this.stateService.user.subscribe((user) => {
            if (user) {
                this.user = user
            }
        });

		Object.keys(this.selectable).forEach(key => {
			this.element.push(this.selectable[key])
			this.panier.removeLineById(key);
			this.stateService.panier.next(this.panier);
			delete(this.selectable[key]);
			if (Object.keys(this.selectable).length==0)
			   	this.disabledAction=true;
			this.changeDetectorRef.detectChanges();
		});

		this.panierService.delete(this.element).subscribe((res: JSONRpcResponse) => {
			if(res){
				console.log('panier:delete ',res)
				if(res.result) {
					let data={
						message:'Element(s) supprimé(s) du panier.',
						methode:"removePanierItems"
					}
					this.reloadPanier(data)
				}
			}
		})

	}

	updateInstructionToUser(){
		this.element = [];

		let element ={
			idLigne: []
		}

		this.stateService.user.subscribe((user) => {
            if (user) {
                this.user = user;
            }
        })
		Object.keys(this.selectable).forEach(key => {
			let line:PanierLine=this.selectable[key];
			element.idLigne.push(this.selectable[key].id)
			this.element.push(line);
		});
		this.dialogService.open(PanierInstructionComponent, {
			data: {
				donnees: this.element,
				user: this.user,
				origine:"reattribution",
                title: "Réattributtion procédures"
			}
		}, (res: any) => {
			if (res){

				this.options = res;
				this.options.instructeur = res.instructeur.ID;
				this.options.id = [];

				for(let i=0;i<this.element.length;i++){
					if(this.element[i].instruction)
						this.options.id.push(this.element[i].instruction.ID);
				}


				this.instructionService.setMultipleID(this.options).subscribe((res) => {
					if (res){
						for(let i=0;i<res.result.length;i++){
							let index = this.panier.findByID(element.idLigne[i])
							if(this.panier.lines[index].instruction
							&& res.result[i].ID == this.panier.lines[index].instruction.ID){
								this.panier.lines[index].instruction = res.result[i]
							}
						}
						let data = {
							message:res.result.length+' procédure(s) modifiée(s).',
							methode:"updateInstructionToUser"
						}
						this.reloadPanier(data)
					}
				});
			} else {
				console.log("Boite dialogue fermée avec erreur")
			}
		});
	}

	nextStep(){

		this.element = [];
		let instruction = [];
		let options = [];

		Object.keys(this.selectable).forEach(key => {
			let line:PanierLine=this.selectable[key];
			this.element.push(line);
		});

		this.dialogService.open(PanierInstructionComponent, {
			data: {
				donnees: this.element,
				user: this.user,
				origine:"etape",
                title: "Changement étape procédures"
			}
		}, (res: any) => {
			if (res.etape && !res.cancel) {
				if(res.etape.length > 0
				&& res.tabID.length > 0){

					for(let i=0;i<this.element.length;i++){
						for(let k=0;k<res.tabID.length;k++){
							if(this.element[i].instruction.ID == res.tabID[k]){
								instruction.push(this.element[i].instruction)
							}
						}
					}
					for(let i=0;i<instruction.length;i++){
						let params = {
							ID:instruction[i].ID,
							type: instruction[i].type.key,
							transition: res.etape[i].key,
							transition_demande_type: res.transition_demande_type ? res.transition_demande_type : null,
							titre: res.titre ? res.titre:null,
							comment:null
						};
						if(params.comment !== undefined
						&& params.comment != "undefined"
						&& params.comment !== null)
							params.comment = res.comment ? res.comment : null;

						options.push(params);
					}


					this.instructionService.setTransitionGroupe(options).subscribe((res: JSONRpcResponse) => {
						if(res){
							for(let i=0;i<this.element.length;i++){
								for(let k=0;k<res.result.length;k++){
									if(this.element[i].instruction.ID == res.result[k].ID){
										this.element[i].instruction = res.result[k];
										console.log("La procédure ID =",this.element[i].instruction.ID,"est passée à l'étape suivante (",this.element[i].instruction.etape.ID,")")
									}
								}
							}
							let data = {
								message:res.result.length+' procédure(s) modifiée(s).',
								methode:"nextEtape"
							}
							this.reloadPanier(data)

						} else {
							console.log("Boite dialogue fermée avec erreur")
						}
					})
				} else {
					console.log("Aucune procédure ayant 1 transition, donc opération impossible")
				}
			}

			if(res.cancel) {
				options = [];

				for(let i=0;i<this.element.length;i++){
					for(let k=0;k<res.tabID.length;k++){
						if(this.element[i].instruction.ID == res.tabID[k]){
							instruction.push(this.element[i].instruction.ID)
						}
					}
				}
				this.instructionService.annulerGroup(instruction).subscribe((res: JSONRpcResponse) => {
					if(res){

						for(let i=0;i<res.result.length;i++){
							if(res.result[i].ID == this.element[i].instruction.ID){
								this.element[i].instruction = res.result[i];
							} else {
								for(let k=0;k<this.element.length;k++){
									if(res.result[i].ID == this.element[k].instruction.ID){
										this.element[k].instruction = res.result[i];
									}
								}
							}
						}
						let data = {
							message: res.result.length+' procédure(s) modifiée(s).',
							methode: "CancelInstru"
						}
						this.reloadPanier(data)
					}
				})
			}
		})
	}

	updateConsult(){
		const consultations = [];
		Object.keys(this.selectable).forEach(key => {
			if(this.selectable[key].consultation !== undefined
			&& this.selectable[key].consultation !== ""
			&& this.selectable[key].consultation !== null){
				consultations.push(this.selectable[key].consultation);

			}
		});
		this.dialogService.open(ConsultationStateChangeDialog, {
			data: {
				title: "Changement d'état",
				consultations: consultations
			}
		}, (res:any)=>{
			if(res){
				res.consultations.forEach(cons => {
					this.panier.lines.forEach((line,index) => {
						if(line.consultation != undefined && line.consultation.ID == cons.ID)
							this.panier.lines[index].consultation = cons;
					});
				});
				let data = {
					message: res.consultations.length+' consultation(s) modifiée(s).',
					methode: "UpdateConsult"
				}
				this.reloadPanier(data);
			}
		})
	}

	updateVisite(){
		const visites = [];

		Object.keys(this.selectable).forEach(key => {
			if(this.selectable[key].visite !== undefined
			&& this.selectable[key].visite !== ""
			&& this.selectable[key].visite !== null){
				visites.push(this.selectable[key].visite)
			}
		});
		this.dialogService.open(ConsultationStateChangeDialog, {
			data: {
				title: "Changement d'état",
				visites: visites
			}
		}, (res:any)=>{
			if(res){
				res.visites.forEach(vis => {
					this.panier.lines.forEach((line,index) => {
						if(line.visite != undefined && line.visite.ID == vis.ID)
							this.panier.lines[index].visite = vis;
					});
				});
				let data = {
					message: res.visites.length+' visite(s) modifiée(s).',
					methode: "UpdateVisite"
				}
				this.reloadPanier(data);
			}
		})

	}

	moveObject(object:any){
		let dateAjd = new Date();
		let monday = formatDate(this.getMonday(dateAjd), 'dd/MM/yyyy', 'fr')
		let options = {
			datedebut:  monday + ' 00:00:00',
			mine:false,
			visite:false
		}
		let consultationList=[];
		let typeInput : [];
		let tab = {
			idLignePanier: [],
			id: [],
			consultation: [],
			type: [],
			visite: []
		};

		Object.keys(this.selectable).forEach(key => {
			if(this.selectable[key].consultation !== undefined
			&& this.selectable[key].consultation !== ""
			&& this.selectable[key].consultation !== null){
				tab.idLignePanier.push(this.selectable[key].id);

				if(tab.id.includes(this.selectable[key].consultation.ID) == false){
					tab.id.push(this.selectable[key].consultation.ID);
					tab.consultation.push(this.selectable[key].consultation);
					tab.type.push(this.selectable[key].consultation.type.key);
				}
			}
			if(this.selectable[key].visite !== undefined
			&& this.selectable[key].visite !== ""
			&& this.selectable[key].visite !== null)

				tab.visite.push(this.selectable[key].visite.ID);
		});

		this.consultationService.consultationListe(options).subscribe((res: JSONRpcResponse) => {
			if(res.result){
				// console.log(res.result)
				for(let i=0;i<res.result.length;i++){
					if(res.result[i].domicile == false
					&& res.result[i].ponctuel == false){
						let str = this.buildMessage(res.result[i])
						res.result[i].display = str;
						consultationList.push(res.result[i]);
					}
				}
				// console.log(consultationList)
				this.changeDetectorRef.detectChanges()
			}

			this.consultationService.getConsultationTypeList().subscribe((res: JSONRpcResponse) => {
				typeInput = res.result
				this.changeDetectorRef.detectChanges()
				this.dialogService.open(ConsultationMoveComponent, {
					data: {
						object:object,
						nbConsult: tab.visite.length,
						type:typeInput,
						consultationsInput:consultationList
					}
				}, (res: any) => {
					if(res && object) {
						switch (object) {
							case 'consultation' :
								if(res.method == 'Déplacer') {
									this.deplacerConsult(tab,res);
									break;
								}
								if(res.method == 'Créer'){
									this.createConsult(tab,res);
									break
								}
							case 'visite' :
								if(res.method == 'Déplacer') {
									this.deplacerVisite(tab,res);
									break;
								}
								if(res.method == 'Créer'){
									this.createVisite(tab,res);
									break;
								}
							default:
								console.log('Erreur dans le processus veuillez recommencer');
						}
					} else {
						console.log("Boite dialogue fermée avec erreur")
					}
				})
			})
		})
	}

	deplacerConsult(tab:any,res:any){
		let params = {
			id:tab.id,
			consultationid: res.consultationid,
			visiteid:tab.visite,
			options: {
				initiative:res.options.initiative,
				type: tab.type,
				typeOldConsult:"ANNULE",
				datedebut: res.options.datedebut,
				datefin:res.options.datefin,
				etatCree:res.options.etatCree.key,
				etatDel:res.options.etatDel.key,
				titre:res.options.titre,
				commentaire:res.options.commentaire,
				// domicile:res.options.domicile,
				// ponctuel:res.options.ponctuel,
			}
		}
		this.visiteService.moveAllFromConsult(params).subscribe((res: JSONRpcResponse) => {
			console.log("methode visite:move", res)
			if(res.result){
				for(let i=0;i<Object.keys(res.result.visite).length;i++){
					let index = this.panier.findByID(tab.idLignePanier[i])
					if(this.panier.lines[index].consultation
					&& res.result.consultation.ID == params.consultationid){
						this.panier.lines[index].consultation = res.result.consultation;
						this.panier.lines[index].visite = res.result.visite[i]
					}
				}
				this.panierService.set(this.panier.lines).subscribe((res: JSONRpcResponse) => {
					if(res){
						console.log("panier:set apres :move",res)
						let data = {
							message: 'Séance(s) modifiée(s).',
							methode: "deplacerConsult"
						}
						this.reloadPanier(data)
					}
				})
			} else if (res.error){
				let snackBarRef = this.snackbar.open(res.error.data,'',{duration:2500});
			}
		})
	}

	deplacerVisite(tab:any,res:any){
		let params = {
			creation:false,
			consultation:{
				old:{
					ID:tab.id,
					type:tab.type,
				},
				consultationID: res.consultationid
			},
			visite:{
				Hash:tab.idLignePanier,
				ID:tab.visite,
			},
			options:{
				initiative:res.options.initiative,
				datedebut:res.options.datedebut,
				datefin:res.options.datefin,
				commentaire:res.options.comment,
				titre:res.options.titre,
				etatCree:res.options.etatCree.key,
				etatDel:res.options.etatDel.key,
				typeOldConsult:"ANNULE",
				// domicile:res.options.domicile,
				// ponctuel:res.options.ponctuel
			}
		}
		this.consultationService.createAndMoveVisite(params).subscribe((res:JSONRpcResponse)=> {
			// console.log(res)
			if(res.result){
				for(let i=0;i<Object.keys(res.result.visite).length;i++){
					let index = this.panier.findByID(tab.idLignePanier[i])
					if(this.panier.lines[index].visite
					&& res.result.consultation.ID == params.consultation.consultationID){
						this.panier.lines[index].consultation = res.result.consultation;
						this.panier.lines[index].visite = res.result.visite[i]
					}
				}
				this.panierService.set(this.panier.lines).subscribe((res: JSONRpcResponse) => {
					if(res){
						console.log("panier:set apres :move",res)
						let data = {
							message: 'RDV(s) modifiée(s).',
							methode: "deplacerVisite"
						}
						this.reloadPanier(data)
					}
				})
			} else if (res.error){
				let snackBarRef = this.snackbar.open(res.error.data,'',{duration:2500});
			}
		})

	}

	createConsult(tab:any,res:any){
		let params = {
			id:tab.id,
			visiteid:tab.visite,
			options: {
				initiative:res.options.initiative,
				type:res.options.type.key,
				typeOldConsult:"ANNULE",
				datedebut: res.datedebut,
				datefin: res.datefin,
				intervalle: res.options.intervalle,
				etatCree: res.options.etat.key,
				etatDel:res.options.etatDel,
				lieu: res.options.lieuID,
				professionels: [res.options.tiersID],
				titre:res.options.titre,
				commentaire:res.options.commentaire,
				domicile: res.options.domicile,
				ponctuel:res.options.ponctuel
			}
		}
		this.consultationService.createAndMoveConsultation(params).subscribe((res: JSONRpcResponse) => {
			console.log("consultation:createAndMoveConsultation",res)
			if(res.result){
				for(let i=0;i<Object.keys(res.result.visite).length;i++){
					let index = this.panier.findByID(tab.idLignePanier[i])
					if(this.panier.lines[index].consultation){
						this.panier.lines[index].consultation = res.result.consultation;
						if(res.result.visite[i].ID == this.panier.lines[index].visite.ID)
							this.panier.lines[index].visite = res.result.visite[i]
					}
				}
				this.panierService.set(this.panier.lines).subscribe((res: JSONRpcResponse) => {
					console.log("panier:set apres :move",res)
					if(res){
						let data = {
							message: 'Séance(s) modifiée(s).',
							methode: "createConsult"
						}
						this.reloadPanier(data)
					}
				})
			} else if (res.error){
				let snackBarRef = this.snackbar.open(res.error.data,'',{duration:2500});
			}
		})
	}

	createVisite(tab:any,res:any) {
		// console.log(res)
		let params = {
			creation:true,
			consultation:{
				old:{
					ID:tab.id,
					type:tab.type,
				},
				consultationID: res.consultationid
			},
			visite:{
				Hash:tab.idLignePanier,
				ID:tab.visite,
			},
			options:{
				domicile:res.options.domicile,
				ponctuel:res.options.ponctuel,
				initiative:res.options.initiative,
				type:res.options.type.key,
				typeOldConsult:"ANNULE",
				datedebut: res.datedebut,
				datefin: res.datefin,
				intervalle: res.options.intervalle,
				etatCree: res.options.etat.key,
				etatDel:res.options.etatDel,
				lieu: res.options.lieuID,
				professionels: [res.options.tiersID],
				titre:res.options.titre,
				commentaire:res.options.commentaire
			}
		}

		this.consultationService.createAndMoveVisite(params).subscribe((res:JSONRpcResponse) => {
			// console.log(res)
			if(res.result){
				for(let i=0;i<Object.keys(res.result.visite).length;i++){
					let index = this.panier.findByID(tab.idLignePanier[i])
					if(this.panier.lines[index].consultation){
						this.panier.lines[index].consultation = res.result.consultation;
						this.panier.lines[index].visite = res.result.visite[i]
					}
				}
				this.panierService.set(this.panier.lines).subscribe((res: JSONRpcResponse) => {
					console.log("panier:set apres :move",res)
					if(res){
						let data = {
							message: 'RDV(s) modifiée(s).',
							methode: "createVisite"
						}
						this.reloadPanier(data)
					}
				})
			} else if (res.error){
				let snackBarRef = this.snackbar.open(res.error.data,'',{duration:2500});
			}
		})
	}

	buildMessage(consultation) {
		let str:string[]=[];
		str.push(consultation.type.libelle)
		str.push("--")
		str.push(formatDate(consultation.date_debut, 'dd/MM/yy, h:mm a','fr') + ' => ' + formatDate(consultation.date_fin,'dd/MM/yy, h:mm a','fr'))

		return str.join(" ");
	}

	getMonday(date: string | number | Date) {
		date = new Date(date)
		let day = date.getDay(),
			diff = date.getDate() - day + (day == 0 ? -6 : 1)
		return new Date(date.setDate(diff))
	}

	getFriday(date: string | number | Date) {
		date = new Date(date)
		let day = date.getDay(),
			diff = date.getDate() + (5 - day) + (day == 0 ? -3 : 0)
		return new Date(date.setDate(diff))
	}

	editSynthese() {

		this.element = [];
		Object.keys(this.selectable).forEach(key => {
			let line:PanierLine=this.selectable[key];
			this.element.push(line.dossier.dossierID);
		} );
		let _options:any={
			filters:[],
			sorts:[]
		}

		console.log("this.listeCode : ", this.listCode)

		this.listService.exports(this.listCode,this.element,_options).subscribe((res: JSONRpcResponse) => {

			console.log("editData SYNTHESE",res);

			if (res.result) {
				for(let i=0;i<res.result.length;i++){
					let r=res.result[i];
					console.log("editData SYNTHESE line",r);
					if (r.datas && r.datas.url!=undefined)
						window.open(r.datas.url);
				}
			}
			this.changeDetectorRef.detectChanges();
		});
  	}

	editCourrier() {
        var lines = [];
		Object.keys(this.selectable).forEach(key => {
			let line:PanierLine=this.selectable[key];
            lines.push(line);
		});

		console.log("this.demande",this.demande,lines)
		const dialogRef=this.dialogService.open(ChoiceCourrierComponent, {
            data: {
                typeDemande: this.demande,
                /*state: this.currentState,*/
                panierLines: lines
                
            },
            width: "30vw",
            draggable: true,
            resizable: true,
            minimizable: true,
            maximizable: true,
        }, (result: any) => {
            if (result) { }
        })

        const sub = dialogRef.componentInstance.onFormClosed.subscribe((result: any) => {
            console.log('Result courriers download',result);
            if(result && result.zipFile && result.zipFile.url){
                //window.open(result.zipFile.url,' _blank');
				
				const dial=this.dialogService.open(LoadDialogComponent, {
	               data: {
	                   url: result.zipFile.url
	               },
				   height: "95vh",
				   width: "80%",
				   minimizable: true,
				   maximizable: true,
				   draggable: true,
	           	}, (res: any) => {
	               
	           	})
            }
            /*
            if (result && result.length>0) {
               for(let i=0;i<result.length;i++) {
	                let r=result[i];
	                if (r.length>0) {
		                let rr=r[0];
		                console.log("createCouurierDialog",rr);
		                if (rr.value!=undefined && rr.value.url!=undefined)
		                	window.open(rr.value.url);
					}
			   	}
			}*/
		})
	}

    getProceduresToCreate(){
        var proceduresToCreate = [];
        if(this.pageInstructions.actions){
            this.pageInstructions.actions.forEach((action: any) => {
                if (action.rights.r) {
                    if (action.parametre) {
                            if(action.parametre.action == "createInstruction"){
                                action.action = () => {
                                    return this.createInstruction(
                                        action.parametre.instruction,
                                        action.parametre.type
                                   );
                                }
                                proceduresToCreate.push(action);
                            }
                    }
                }
            })
        }
        return proceduresToCreate;
    }

    createInstruction(instruction:any, type:any): void {
        let dataIns={
            action: "create",
            dataType: "consultation",
            code: type,
            dossier: this.panier.lines,
            title: "Création des procédures ("+this.panier.lines.length+")",
            create: true,
            instruction_type: instruction,
            typeDossier: "multi"
            }
        this.dialogService.open(InstructionActionsDialog, {
                    data: dataIns,
                    width: '50vw',
                    draggable: true,
                    maximizable: true,
                    minimizable: true,
                    resizable: true,
                }, (res: any) => {
                    console.log(res)
                    if (res) {
	                    let _refresh={
							type: "instruction",
							data:dataIns
						};

	                    this.stateService.updateRefresh(_refresh)
                    }

           })
    }
    
    vider() {
		this.panier.wideLines();
        Object.keys(this.selectable).forEach(key => {
            
            delete(this.selectable[key]);
            if (Object.keys(this.selectable).length==0)
                   this.disabledAction=true;
            this.changeDetectorRef.detectChanges();
        });
		this.panierService.vider().subscribe((res: JSONRpcResponse) => {
			let data = {
								message:'Panier vidé.',
								methode:"vider"
							}
			this.reloadPanier(data)
		});
		
		
		this.disabledAction=true;
		this.wideAction=true;
		this.changeDetectorRef.detectChanges();
		
	}

    addVisite(){
        let dossiers = [];
        Object.keys(this.selectable).forEach(key => {
			dossiers.push(this.selectable[key].dossier);            
		} );
        console.log("addVisite dossiers",dossiers);
        const dialogRef = this.dialogService.open(VisiteActionsDialog, {
            data: {
                action: "create",
                dataType: "rdv",
                lots: dossiers,
                title: "Création d'un rendez-vous",
                create: true,
            },
            height: "95vh",
            width: "80vw",
            draggable: true,
            resizable: true,
            minimizable: true,
            maximizable: true,
        })
    }

	shiftConsult(){
		const consultations = [];
		Object.keys(this.selectable).forEach(key => {
			if(this.selectable[key].consultation !== undefined
			&& this.selectable[key].consultation !== ""
			&& this.selectable[key].consultation !== null){
				consultations.push(this.selectable[key].consultation);

			}
		});
		this.dialogService.open(ConsultationShiftDialog, {
			data: {
				title: "Décalage de séances",
				consultations: consultations
			}
		}, (res:any)=>{
			if(res){
				res.consultations.forEach(cons => {
					this.panier.lines.forEach((line,index) => {
						if(line.consultation != undefined && line.consultation.ID == cons.ID)
							this.panier.lines[index].consultation = cons;
					});
				});
				let data = {
					message: res.consultations.length+' consultation(s) et ' + res.visites.length + ' visites modifiées',
					methode: "shiftConsult"
				}
				this.reloadPanier(data);
			}
		})
	}
}
